export default __webpack_public_path__ + "static/media/Remolque Agrícola1.bce35b88.png";